import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback } from 'react';
import { Configuration } from '../../../Domain/DTOs/Configuration/ConfigurationDTO';
import { component } from '../../Decorators/Component';
import { InputView } from '../Inputs/InputView';
import { SmallView } from '../Typography/SmallView';
import { CoreConfig } from '../../../CoreConfig';
export const ChoiceItemInputView = component({
    provider: CoreConfig.provider,
    moduleName: CoreConfig.moduleName,
    componentName: Configuration.ComponentNames.choiceItemInput,
    style(theme, mediaQuery, window, props) {
        return {
            container: {},
            end: {},
            start: {},
            title: {},
            description: {},
            input: {
                minWidth: 240,
                minHeight: 48,
            },
            inputText: {
                fontSize: 16,
                lineHeight: 18
            }
        };
    }
})(({ style, value, id, testID, onChange, title, description, disabled, customize }) => {
    const handleChange = useCallback((text) => {
        !disabled && (onChange === null || onChange === void 0 ? void 0 : onChange(id, text));
    }, []);
    return (_jsx(InputView, { testID: `choice-item-${testID || title || ''}`, underline: false, containerStyle: style === null || style === void 0 ? void 0 : style.input, label: customize === null || customize === void 0 ? void 0 : customize.label, before: (customize === null || customize === void 0 ? void 0 : customize.prefix)
            ? () => (_jsx(SmallView, { textStyle: style === null || style === void 0 ? void 0 : style.inputText, children: customize === null || customize === void 0 ? void 0 : customize.prefix }))
            : undefined, after: (customize === null || customize === void 0 ? void 0 : customize.suffix)
            ? () => (_jsx(SmallView, { textStyle: style === null || style === void 0 ? void 0 : style.inputText, children: customize === null || customize === void 0 ? void 0 : customize.suffix }))
            : undefined, placeholder: customize === null || customize === void 0 ? void 0 : customize.placeholder, value: value, onChangeText: handleChange, disabled: disabled, keyboardType: customize === null || customize === void 0 ? void 0 : customize.keyboardType }));
});
